import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { ListGroup, ListGroupItem } from 'reactstrap';

import { api } from '../../utils/api';

class SearchSuggestions extends Component {
  constructor(props){
    super(props);
    this.state = {
      items: []
    }
  }
  fetchItems = () => {
    fetch(api+'/topics')
      .then(res => res.json())
        .then(items => this.setState({ items }))
  }
  handleSubmit = (value) => {
    this.props.history.push(`/search?q=${value}`);
  }
  componentDidMount(){
    this.fetchItems();
  }
  render(){
    return (
      this.state.items.length > 0 &&
      <div className="mx-auto bg-white p-0 text-left" style={{ overflow: 'hidden', backgroundColor: 'rgb(220,220,220)' }}>
        <h6 className="mx-3 py-2 text-muted"><small className="font-weight-bold">Oft gesucht</small></h6>
        <ListGroup flush className="mx-auto">
        { this.state.items.sort((a,b) => a.count < b.count).sort((a,b) => a.count < b.count).map((item, index) =>
          <ListGroupItem tabIndex={ index+2 } key={item.name} tag="button" action className="d-flex justify-content-between align-items-center py-2 paul-search-suggestion" onClick={() => this.handleSubmit(item.name)}>
            <span>{ item.name }</span>
            <small className="text-secondary"><strong>{ item.count }</strong> Ergebnisse</small>
          </ListGroupItem>
        )}
        </ListGroup>
      </div>
    )
  }
}


export default withRouter(SearchSuggestions);



// WEBPACK FOOTER //
// ./src/components/ui-elements/SearchSuggestions.js